import React from 'react';

import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

import { useAIRovoButtonEnablement } from '@confluence/ai-common/entry-points/useAIRovoButtonEnablement.ts';
import { AISmartButtonWrapper } from '@confluence/ai-rovo-button/entry-points/AISmartButtonWrapper.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { RegisteredExperience } from '@confluence/rovo-config-provider-common/entry-points/rovoConfigTypes.ts';
import { RovoConfigProvider } from '@confluence/rovo-config-provider-common/entry-points/RovoConfigProvider.ts';

import { HomeRovoConfigProvider } from './HomeRovoConfigProvider.tsx';

const rovoButtonPositionStyles = xcss({
	position: 'fixed',
	insetBlockEnd: 'space.300',
	insetInlineEnd: 'space.300',
	zIndex: 'dialog',
});

export const HomeRovoButtonContainer = (): React.JSX.Element | null => {
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	if (!isRovoButtonEnabled || !expValEquals('rovo-button-confluence-home', 'isEnabled', true)) {
		return null;
	}

	return (
		<>
			<RovoConfigProvider
				experience={RegisteredExperience.HOME}
				provider={HomeRovoConfigProvider}
			/>
			<Box xcss={rovoButtonPositionStyles}>
				<AISmartButtonWrapper contentId="" contentType="" pageMode="home" isDisabled={false} />
			</Box>
		</>
	);
};
